import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Constants} from "../../constants";
import {environment} from "../../environments/environment";
import {Message} from "../../models/message";

@Injectable({
    providedIn: 'root'
})
export class MessageService {

    constructor(private http: HttpClient) {
    }

    getRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    getPublicRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': environment.publicApiToken,
        });
    }

    async getAllMessages() {
        let response: any;

        try {

            response = await this.http.get(environment.apiUrl + '/messages', {headers: this.getRequestHeaders()}).toPromise();

        } catch (e) {
            console.error('error getAllMessages: ', e)
        } finally {
          return response;
        }
    }

    async getMessageById(messageId: string){

        let response: any;

        try {
            response = this.http.get(environment.apiUrl + `/messages/${messageId}`, {headers: this.getRequestHeaders()}).toPromise();

        } catch (e){
            console.error('error getMessageById: ', e)
        } finally {
            return response;
        }

    }

    async createMessage(message: Message){
        let response: any;

        try {
            response = await this.http.post(environment.apiUrl + '/messages', message, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error createMessage: ', e)
        } finally {
            return response;
        }
    }

    async markMessageAsSeen(messageId: string){
        let response: any;

        try {
            response = await this.http.put(environment.apiUrl + `/messages/${messageId}/seen`, {seen: 1}, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error createMessage: ', e)
        } finally {
            return response;
        }
    }

    async getMessageRecipients(messageId: string) {
        let response: any;

        try {
            response = await this.http.get(environment.apiUrl + `/messages/${messageId}/recipients`, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error getMessageRecipients: ', e);
        } finally {
            return response;
        }
    }

    async getSentMessages() {
        let response: any;

        try {
            response = await this.http.get(environment.apiUrl + '/messages/sent', { // Modifica qui l'URL
                headers: this.getRequestHeaders()
            }).toPromise();
        } catch (e) {
            console.error('error getSentMessages: ', e);
        } finally {
            return response;
        }
    }




}
